module.exports = __webpack_public_path__ + "img/Calculate.13cd5d25.svg";